const major = 1;
const minor = 10;
const patch = 2;

module.exports = `${major}.${minor}.${patch}`;
